import BsTooltip from "./BsTooltip";

export default Vue => {
    Vue.component(BsTooltip.name, BsTooltip);
};
